/**
 * 应用参数管理工具
 * @author Tim
 * @date 2024-08-27
 */

import { get } from '@/lib/request.js';

// 存储应用参数的对象
let appParams = {};

/**
 * 初始化应用参数
 * 从服务器获取应用参数并存储到内存中
 * @returns {Promise} 获取参数的Promise对象
 */
export function initAppParams() {
  return new Promise((resolve, reject) => {
    console.log('开始获取应用参数...');
    
    get('apis/client/application/params')
      .then(res => {
        if (res.code === 0) {
          appParams = res.data || {};
          console.log('应用参数获取成功:', appParams);
          resolve(appParams);
        } else {
          console.error('应用参数获取失败:', res.message || res.msg);
          // 即使获取失败也初始化一个空对象
          appParams = {};
          reject(new Error(res.message || res.msg));
        }
      })
      .catch(err => {
        console.error('应用参数请求异常:', err);
        // 出错时确保参数对象被初始化
        appParams = {};
        reject(err);
      });
  });
}

/**
 * 获取指定键的应用参数值
 * @param {string} key 参数键名
 * @param {any} defaultValue 默认值，如果参数不存在则返回此值
 * @returns {any} 参数值或默认值
 */
export function getParam(key, defaultValue = null) {
  if (!key) {
    console.warn('getParam: 参数键名不能为空');
    return defaultValue;
  }
  
  // 如果参数存在则返回，否则返回默认值
  return appParams.hasOwnProperty(key) ? appParams[key] : defaultValue;
}

/**
 * 获取所有应用参数
 * @returns {Object} 所有应用参数
 */
export function getAllParams() {
  return { ...appParams }; // 返回副本，避免外部修改
}

/**
 * 检查是否有指定键的参数
 * @param {string} key 参数键名
 * @returns {boolean} 是否存在该参数
 */
export function hasParam(key) {
  if (!key) return false;
  return appParams.hasOwnProperty(key);
} 